import { useEffect, useRef } from "react";
import { useAuthContext } from "../providers/AuthContext";
import { useCartContext } from "../providers/CartContext";
import { useWarehouseContext } from "../providers/WarehouseContext";

const CartEffects = () => {
  const { isAuthenticated } = useAuthContext();
  const { loadCotizacionFromBackend, resetCart } = useCartContext();
  const { selectedAlmacen } = useWarehouseContext();
  const prevIsAuthRef = useRef(isAuthenticated);

  useEffect(() => {
    if (isAuthenticated && selectedAlmacen) {
      loadCotizacionFromBackend(selectedAlmacen);
    }
  }, [isAuthenticated, selectedAlmacen, loadCotizacionFromBackend]);

  useEffect(() => {
    if (prevIsAuthRef.current && !isAuthenticated) {
      resetCart();
    }
    prevIsAuthRef.current = isAuthenticated;
  }, [isAuthenticated, resetCart]);

  return null;
};

export default CartEffects;
